import React from 'react';

import { Svg, type SvgProps } from './svg';

export function CodeIcon(props: SvgProps) {
  return (
    <Svg data-testid="code-icon" {...props}>
      <path d="M14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6ZM9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6Z" />
    </Svg>
  );
}
